import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import VueSound from 'vue-sound';
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from 'bootstrap-vue'

import Aplayer from 'vue-aplayer'
Vue.component('aplayer', Aplayer)

import PortFolio from "./components/Portfolio"
Vue.component('portfolio', PortFolio)

import Client from "./components/Clients"
Vue.component('client', Client)
//init vue cookie
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);



// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'



//install Axios
Vue.use(VueAxios, axios)



Vue.config.productionTip = false;

export const globalSiteSetting = new Vue({
  data: {
    
     //siteurl: 'http://192.168.239.63:8888/graphikoapi'
     //siteurl: 'http://10.20.30.7:8888/graphikoapi'
    siteurl: 'https://graphikodesign.com/graphikoapi'
    //siteurl: 'http://www.capfor.mg/temp_api'
    //siteurl: 'https://www.gilbertrakotomanana.com'

  }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {

  }
}).$mount('#app');
